
import NetworkLogic from "../Shared/NetworkLogic";
import Utils from "../Shared/Utils";
import UIManager from "../Shared/UIManager";
import { Global } from "../Shared/Global";
import AudioManager from "../Shared/AudioManager";
import Player from "../Models/Player";
import SDKManager from "../Shared/SDKManager";
import Constant from "../Shared/Constant";
import RemoteSprite from "../Common/RemoteSprite";
import HallUI from "./HallUI";
const i18n = require('LanguageData');


const { ccclass, property } = cc._decorator;

@ccclass
export default class LoginQuickRegister extends cc.Component {
    @property(cc.Node)
    nodeBtnClose: cc.Node = null;
    @property(cc.EditBox)
    edUserId: cc.EditBox = null;
    @property(cc.EditBox)
    edPassword: cc.EditBox = null;

    @property(cc.Node)
    nodeEditBtn1: cc.Node = null;
    @property(cc.Node)
    nodeEditBtn2: cc.Node = null;
    @property(cc.Node)
    nodeCheckBtn1: cc.Node = null;
    @property(cc.Node)
    nodeCheckBtn2: cc.Node = null;
    @property(cc.Node)
    nodeSaveImage: cc.Node = null;

    @property(cc.Label)
    userId1: cc.Label = null;
    @property(cc.Label)
    password1: cc.Label = null;

    @property(cc.Node)
    nodeBtnOk: cc.Node = null;
    @property(cc.Node)
    nodeBtnSave: cc.Node = null;
    @property(cc.Label)
    currencyLabel: cc.Label = null;
    @property(cc.Label)
    languageLabel: cc.Label = null;

    @property(RemoteSprite)
    languageIcon: RemoteSprite = null;
    @property(cc.Node)
    langToggleItem: cc.Node = null;
    @property(cc.Node)
    langToggleContent: cc.Node = null;
    @property(cc.Node)
    currencyToggleItem: cc.Node = null;
    @property(cc.Node)
    currencyToggleContent: cc.Node = null;
    @property(cc.Node)
    nodeLangScroll: cc.Node = null;
    @property(cc.Node)
    nodeCurrencyScroll: cc.Node = null;
    @property(cc.Node)
    nodePosCur: cc.Node = null;
    @property(cc.Node)
    nodeTips: cc.Node = null;
    @property(cc.Node)
    currencyTips: cc.Node = null;

    currencyLanguageDto = null;
    _languageData = null
    check1 = true;
    check2 = true;

    //private _channelCode: string = ""
    //private _bindData: {} = null

    onLoad() {

    }

    async start() {

        let bQuickLogin = cc.sys.localStorage.getItem("OpenLoginQuickRegister");

        if (bQuickLogin){
            cc.sys.localStorage.setItem("OpenLoginQuickRegister","")
            UIManager.showLoadingUI()
            NetworkLogic.loginVisitorCreate(function (rec) {
                UIManager.hideLoadingUI()
                this.updateUI(rec);
            }.bind(this), function (rec) {
                cc.log("===获取游客账号失败:", rec);
                UIManager.showToastUI(i18n.t('login_text.quick_login_fail'), Global.ToastType.Error)
            });
        }


        await this.getLanguageData();

        let data = {
            agentCode: Global.installParms.length === 2 ? Global.installParms[1]['code'] : ""
            //agentCode: "992e9wv3wa3l"
        }
        UIManager.showLoadingUI();
        NetworkLogic.userLoginConfig(data, function (data) {
            UIManager.hideLoadingUI();
            if (!Array.isArray(data.currencyLanguageDto) || data.currencyLanguageDto.length <= 0) return;
            this.currencyLabel.node.parent.parent.active = (data.currencyLanguageDto.length > 1)
            if (data.currencyLanguageDto.length === 1) {
                this.onBtnCurrencySelected(null, data.currencyLanguageDto[0]);
                let btn = this.currencyLabel.node.parent.getComponent(cc.Button)
                btn.interactable = false;
                btn.node.getChildByName("spXiala").active = false;

            } else {
                this.createCurrencyList(data.currencyLanguageDto);
            }
            cc.log("====userLoginConfig data:", data);
        }.bind(this), function () {

        }.bind(this))

    }

    createCurrencyList(currencyList){
        for (let i = 0;i < currencyList.length;i++){
            let item = cc.instantiate(this.currencyToggleItem);
            item.parent = this.currencyToggleContent;
            item.getChildByName("lbBack").getComponent(cc.Label).string = currencyList[i].currencyName ;
            item.getComponent(cc.Button).clickEvents[0].customEventData = currencyList[i];
            item.active = true;
        }
        //this.currencyLabel.string = this.currencyLanguageDto.currencyName;
    }

    updateUI(rec) {
        this.edUserId.string = rec.userId;
        this.edPassword.string = rec.password;
    }



    onBtnEdit1() {
        AudioManager.playSound("button");
        this.edUserId.enabled = true;
        this.nodeEditBtn1.active = false;
        this.nodeCheckBtn1.active = true;

        this.check1 = false;
    }

    onBtnEdit2() {
        AudioManager.playSound("button");
        this.edPassword.enabled = true;
        this.nodeEditBtn2.active = false;
        this.nodeCheckBtn2.active = true;

        this.check2 = false;
    }

    onBtnCheck1() {
        AudioManager.playSound("button");
        let data = {
            "userId": this.edUserId.string,
            "pwd": this.edPassword.string
        }
        NetworkLogic.loginVisitorVerification(data, function (rec) {
            cc.log("===修改账号成功", rec);
            this.edUserId.enabled = false;
            this.check1 = true;
            this.nodeCheckBtn1.active = false;

        }.bind(this), function () {
            cc.log("===失败原因呢");//肯能是账号重复之类对
        });
    }

    onBtnCheck2() {
        AudioManager.playSound("button");
        this.edPassword.enabled = true;
        let data = {
            "userId": this.edUserId.string,
            "pwd": this.edPassword.string
        }
        NetworkLogic.loginVisitorVerification(data, function (rec) {
            cc.log("===修改密码成功", rec);
            this.edPassword.enabled = false;
            this.check2 = true;
            this.nodeCheckBtn2.active = false;
        }.bind(this), function () {
            cc.log("===失败原因呢");//肯能是账号重复之类对
        });
    }

    onBtnOk() {
        AudioManager.playSound("button");
        if (!this.check1 || !this.check2 ) {

            UIManager.showToastUI(i18n.t('register_text.please_tick'), Global.ToastType.Warnning)
            return;
        }
        if  (!this.currencyLanguageDto){
            UIManager.showToastUI(i18n.t('register_chooseCurrency'), Global.ToastType.Warnning)
            return;
        }
        cc.log("====设备号：", Utils.getDeviceId());
        //cc.log("====设备型号：",jsb.device.getDeviceModel());
        this.userId1.string = this.edUserId.string;
        this.password1.string = this.edPassword.string;
        let data = {
            "deviceModel": cc.sys.isMobile ? jsb.device.getDeviceModel() : "",
            "deviceType": cc.sys.os === cc.sys.OS_ANDROID ? "1" : "2",
            "domainId": Global.installParms.length === 2 ? Global.installParms[0] : "",
            "parentAgentCode": Global.installParms.length === 2 ? Global.installParms[1]['code'] : "",
            "pwd": this.edPassword.string,
            "userId": this.edUserId.string,
            "currencyType" : this.currencyLanguageDto.currencyType

        }
        UIManager.showLoadingUI()
        NetworkLogic.loginVisitorRegistered(data, function (rec) {
            UIManager.hideLoadingUI()
            cc.log("===注册成功", rec);
            if (Constant.InstallSDK === 0) {
                SDKManager.reportRegister()
            }else if (Constant.InstallSDK === 1) {
                SDKManager.shareInstallReportRegister()
            }
            this.nodeBtnOk.active = false;
            this.nodeBtnSave.active = true;
            cc.director.emit(Global.UserEvent.AfterLogin);//登录之后

            Player.setPy("token", rec.token)
            cc.log("====注册成功之后AfterLogin token：", Player.getPy("token"));
            //cc.sys.localStorage.setItem(Global.localStorageId.QuickLoginUserId, this.edUserId.string);
        }.bind(this), function () {
            UIManager.hideLoadingUI()
            cc.log("===loginVisitorRegistered失败原因呢");//肯能是账号重复之类对
            this.node.destroy();
        }.bind(this));
    }

    onBtnSave() {
        AudioManager.playSound("button");
        if (!cc.sys.isNative) {
            cc.log("该方法只支持原生平台");
            this.nodeBtnClose.active = true;
            return
        }
        Utils.saveNodeImageToAlbum(this.nodeSaveImage, "userIdAndPassword" + ".png", function (success) {
            if (success) {
                UIManager.showToastUI(i18n.t('register_text.save_suc'), Global.ToastType.OK);
                this.node.destroy();
            } else {
                UIManager.showTipUI(i18n.t('register_text.save_err'), Global.ToastType.Error);
                this.nodeBtnClose.active = true;
            }
        }.bind(this));
    }

    onBtnClose() {
        AudioManager.playSound("close");
        this.node.destroy();
    }



    private initLanguageToggles() {
        if (!Array.isArray(this._languageData) || this._languageData.length <= 0) return;
        this.languageLabel.node.parent.active = (this._languageData.length > 1)
        if (this._languageData.length === 1) {
            this.onLangToggleSelected(null, this._languageData[0]);
            let btn = this.languageLabel.node.parent.getChildByName("btn").getComponent(cc.Button)
            btn.interactable = false;
            btn.node.getChildByName("xiala").active = false;
            let data = this._languageData[0];
            this.languageLabel.string = data.languageName;
            this.languageIcon.url = data.languageUrl;
        } else {
            let language = cc.sys.localStorage.getItem("CurrentLanguage")
            for (let j = 0; j < this._languageData.length; j++) {
                const data = this._languageData[j];
                if (data.status !== 1) {
                    continue
                }
                let togItem = cc.instantiate(this.langToggleItem);
                togItem.parent = this.langToggleContent;
                cc.find("lbBack", togItem).getComponent(cc.Label).string = data.languageName;
                //cc.find("checkmark/lbCheck",togItem).getComponent(cc.Label).string = data.languageName;
                togItem.getChildByName("icon").getComponent(RemoteSprite).url = data.languageUrl;
                togItem.active = true;
                let tog = togItem.getComponent(cc.Button)
                tog.clickEvents[0].customEventData = data;
                if (language === data.languageFlag) {
                    this.languageLabel.string = data.languageName;
                    this.languageIcon.url = data.languageUrl;

                    this.onLangToggleSelected(null, data);
                }
            }
        }
    }

    onLangToggleSelected(event,param){
        AudioManager.playSound("button")
        cc.log("===进入 语言Toggle param：",param);
        let language = cc.sys.localStorage.getItem("CurrentLanguage")
        if  (language === param.languageFlag){
            this.nodeLangScroll.active = false;
            return
        }
        this.languageLabel.string = param.languageName;
        this.languageIcon.url = param.languageUrl;
        this.nodeLangScroll.active = false;
        SDKManager.setTags([param.languageFlag])
        i18n.init(param.languageFlag)
        cc.sys.localStorage.setItem("CurrentLanguage", param.languageFlag);
        cc.sys.localStorage.setItem("OpenLoginQuickRegister", "LoginQuickRegister");

        UIManager.showTipUI(i18n.t("set_text.change_language_tips"), function () {
            Utils.restartGame()
        }.bind(this), i18n.t("set_text.restart"))

    }

    onBtnCurrencySelected(event,param){
        AudioManager.playSound("button")
        this.currencyTips.active = false;

        this.currencyLanguageDto = param;
        this.currencyLabel.string = param.currencyName;
        this.nodeCurrencyScroll.active = false;

    }

    onCloseLang(){
        this.nodeLangScroll.active = false;

    }

    onBtnChooseLanguage(){
        AudioManager.playSound("button")
        this.nodeLangScroll.active = !this.nodeLangScroll.active;
    }

    onBtnChooseCurrency(){
        AudioManager.playSound("button")
        //this.nodeCurrencyScroll.position = Utils.local_world__POS(this.nodePosCur);
        this.nodeCurrencyScroll.active = !this.nodeCurrencyScroll.active;
    }

    onBtnCloseTips(){
        AudioManager.playSound("button")
        this.nodeTips.active = false;
    }

    onBtnTips(){
        AudioManager.playSound("button")
        this.nodeTips.active = true;
    }

    private getLanguageData () : Promise<any> {
        return new Promise<any>(resolve => {
            UIManager.showLoadingUI()
            NetworkLogic.getLanguageListAll(function (data) {
                UIManager.hideLoadingUI();
                this._languageData = data;
                this.initLanguageToggles();

                resolve(data)
            }.bind(this), function (response) {
                UIManager.hideLoadingUI();
                resolve([])
            }.bind(this))
        })
    }
}
